import { Record, Map } from 'immutable';
import moment from 'moment-timezone';
import { camelizeKeys } from 'humps';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

export default class Review extends Record({
  rating: null,
  locationId: null,
  bookingId: null,
  createdAt: null,
}) {
  constructor(props) {
    if (!props) {
      super();
      return;
    }

    const reviewProps = camelizeKeys(omitBy(props, isNil));

    super({
      ...reviewProps,
      createdAt: moment(reviewProps.createdAt),
    });
  }
}

export const Reviews = reviews => Map((reviews || []).filter(r => r).reduce((a, r) => {
  const review = new Review(r);
  a[review.bookingId.toString()] = review; // eslint-disable-line no-param-reassign
  return a;
}, {}));
